import api from '../../config/api';
import request from '../../lib/request';
import { FileDetailDTO } from './models/file-detail-dto';
import { FileTranscodeDTO } from './models/file-transcode-dto';

export interface ApiPostApiFilesParams {
  /** 云服务提供者 */
  provider: string;
  /** 请求体 */
  data: string[];
}
/**
 * 批量查询文件(根据文件ID查询)
 * 批量查询文件(根据文件ID查询)
 * @see https://gateway.devp.eastedu.ltd/swagger-ui/index.html?urls.primaryName=file-service%20(openapi%203.0)#/%E6%96%87%E4%BB%B6%E6%9F%A5%E8%AF%A2%E6%8E%A5%E5%8F%A3(v3.0)/getFilesById
 */
export async function apiPostApiFiles(params: ApiPostApiFilesParams): Promise<FileDetailDTO[]> {
  const { data, ...queryParams } = params;
  return request('baseUrl|/file-service/api/files?version=3.0', {
    method: 'POST',
    params: queryParams,
    data: data,
    baseURL: api.gateway,
  }).then((res) => res.data);
}

export interface ApiPostApiFilesOldIdParams {
  /** 云服务提供者 */
  provider: string;
  /** 请求体 */
  data: string[];
}
/**
 * 批量查询文件(根据OLD_ID查询)
 * 批量查询文件(根据OLD_ID查询)
 * @see https://gateway.devp.eastedu.ltd/swagger-ui/index.html?urls.primaryName=file-service%20(openapi%203.0)#/%E6%96%87%E4%BB%B6%E6%9F%A5%E8%AF%A2%E6%8E%A5%E5%8F%A3(v3.0)/getFilesByOldId
 */
export async function apiPostApiFilesOldId(
  params: ApiPostApiFilesOldIdParams,
): Promise<FileDetailDTO[]> {
  const { data, ...queryParams } = params;
  return request('baseUrl|/file-service/api/files/old_id?version=3.0', {
    method: 'POST',
    params: queryParams,
    data: data,
    baseURL: api.gateway,
  }).then((res) => res.data);
}

export interface ApiPostApiFilesMd5Params {
  /** 云服务提供者 */
  provider: string;
  /** 请求体 */
  data: string[];
}
/**
 * 批量查询文件(根据MD5查询), 由于多存储桶独立性的原因，建议业务使用文件ID查询
 * 批量查询文件(根据MD5查询), 由于多存储桶独立性的原因，建议业务使用文件ID查询
 * @see https://gateway.devp.eastedu.ltd/swagger-ui/index.html?urls.primaryName=file-service%20(openapi%203.0)#/%E6%96%87%E4%BB%B6%E6%9F%A5%E8%AF%A2%E6%8E%A5%E5%8F%A3(v3.0)/getFilesByMd5
 */
export async function apiPostApiFilesMd5(
  params: ApiPostApiFilesMd5Params,
): Promise<FileDetailDTO[]> {
  const { data, ...queryParams } = params;
  return request('baseUrl|/file-service/api/files/md5?version=3.0', {
    method: 'POST',
    params: queryParams,
    data: data,
    baseURL: api.gateway,
  }).then((res) => res.data);
}

export interface ApiPostApiFilesGuidParams {
  /** 云服务提供者 */
  provider: string;
  /** 请求体 */
  data: string[];
}
/**
 * 批量查询文件(根据GUID查询), 由于多存储桶独立性的原因，建议业务使用文件ID查询
 * 批量查询文件(根据GUID查询), 由于多存储桶独立性的原因，建议业务使用文件ID查询
 * @see https://gateway.devp.eastedu.ltd/swagger-ui/index.html?urls.primaryName=file-service%20(openapi%203.0)#/%E6%96%87%E4%BB%B6%E6%9F%A5%E8%AF%A2%E6%8E%A5%E5%8F%A3(v3.0)/getFilesByGuid
 */
export async function apiPostApiFilesGuid(
  params: ApiPostApiFilesGuidParams,
): Promise<FileDetailDTO[]> {
  const { data, ...queryParams } = params;
  return request('baseUrl|/file-service/api/files/guid?version=3.0', {
    method: 'POST',
    params: queryParams,
    data: data,
    baseURL: api.gateway,
    noUserId: true,
  } as any).then((res) => res.data);
}

export interface ApiGetApiFilesPlayIdParams {
  /** 云文件ID值 */
  playId: string;
  /** 云服务提供者 */
  provider: string;
}
/**
 * 根据PlayId获取文件
 * 根据PlayId获取文件
 * @see https://gateway.devp.eastedu.ltd/swagger-ui/index.html?urls.primaryName=file-service%20(openapi%203.0)#/%E6%96%87%E4%BB%B6%E6%9F%A5%E8%AF%A2%E6%8E%A5%E5%8F%A3(v3.0)/getFileByPlayId
 */
export async function apiGetApiFilesPlayId(
  params: ApiGetApiFilesPlayIdParams,
): Promise<FileDetailDTO> {
  const { playId, ...queryParams } = params;
  return request(`/file-service/api/files/${playId}?version=3.0`, {
    method: 'GET',
    params: queryParams,
    baseURL: api.gateway,
    noUserId: true,
    noLeagueId: true,
  } as any).then((res) => res.data);
}

export interface ApiGetApiFilesIdParams {
  /** 文件ID值 */
  id: string;
  /** 是否检查状态 */
  checkState?: boolean;
}
/**
 * 根据ID(老ID也支持)获取文件
 * 根据ID(老ID也支持)获取文件
 * @see https://gateway.devp.eastedu.ltd/swagger-ui/index.html?urls.primaryName=file-service%20(openapi%203.0)#/%E6%96%87%E4%BB%B6%E6%9F%A5%E8%AF%A2%E6%8E%A5%E5%8F%A3(v3.0)/getFileById
 */
export async function apiGetApiFilesId(params: ApiGetApiFilesIdParams): Promise<FileDetailDTO> {
  const { id, ...queryParams } = params;
  return request(`/file-service/api/files/${id}?version=3.0`, {
    method: 'GET',
    params: queryParams,
    baseURL: api.gateway,
    ignoreLoading: true,
    noUserId: true,
    noLeagueId: true,
  } as any).then((res) => res.data);
}

export interface ApiGetApiFilesPreviewsIdParams {
  /** 文件ID值 */
  id: string;
  /** 码率模板，默认为原码 */
  definition?: string;
  /** 云服务提供者 */
  provider: string;
}
/**
 * 根据文件Id获取转码文件
 * 根据文件Id获取转码文件
 * @see https://gateway.devp.eastedu.ltd/swagger-ui/index.html?urls.primaryName=file-service%20(openapi%203.0)#/%E6%96%87%E4%BB%B6%E6%9F%A5%E8%AF%A2%E6%8E%A5%E5%8F%A3(v3.0)/getPreviewByFileId
 */
export async function apiGetApiFilesPreviewsId(
  params: ApiGetApiFilesPreviewsIdParams,
): Promise<FileTranscodeDTO> {
  const { id, ...queryParams } = params;
  return request(`/file-service/api/files/${id}/previews?version=3.0`, {
    method: 'GET',
    params: queryParams,
    baseURL: api.gateway,
    ignoreLoading: true,
    noUserId: true,
    noLeagueId: true,
  } as any).then((res) => res.data);
}
